import Vue from 'vue'
import Vuex from 'vuex'
// modules
import rootModules from './rootModules'
import user from './modules/user'
import globalVariable from './modules/globalVariable'
import getters from './getters'
rootModules.getters = getters

Vue.use(Vuex)

const files = require.context('./modules', false, /\.js$/)
files.keys().forEach(key => {
  const store = files(key).default
  const moduleName = key.replace(/^\.\//, '').replace(/\.js$/, '')
  // console.log(key, store, moduleName)
  rootModules.modules[moduleName] = store
  rootModules.modules[moduleName].namespaced = true
})
// rootModules.modules.user = user
// rootModules.modules.globalVariable = globalVariable
// console.log('rootModules', rootModules)
const store = new Vuex.Store(rootModules)
export default store
